
import { Component, Vue } from 'vue-property-decorator'
import ManageNoticeDetail from '@/components/templates/manage/ManageNoticeDetail.vue'
import { NotificationType } from '@/const/NotificationType'
import { NoticeMessageData } from '@/models/NoticeMessage'
import { NotificationsApi } from '@/api/methods/NotificationsApi'
import { NotificationsApi as ManageNotificationsApi } from '@/api/methods/manage/NotificationsApi'

/**
 * お知らせメッセージ詳細画面
 */
@Component({
  components: {
    ManageNoticeDetail,
  },
})
export default class AcademyNoticeDetail extends Vue {
  /** メッセージ情報 */
  private message!: NoticeMessageData

  /** ページレンダリング制御用フラグ */
  private viewPage = false

  /**
   * お知らせID
   *
   * @returns お知らせID
   */
  private get messageId(): number {
    return Number(this.$route.params.id)
  }

  /**
   * 編集可否の取得
   *
   * @returns 編集可否
   */
  private get isEditable(): boolean {
    return this.message.type === NotificationType.ACADEMY.code
  }

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    this.$loading.start()

    // お知らせ情報取得
    this.message = await this.getMessage()

    this.viewPage = true

    this.$loading.complete()
  }

  /**
   * 戻るボタン押下時の処理
   */
  private eventClickBackButton(): void {
    // 遷移元ページ情報の復元
    const prevPage = this.$prevPage.restorePage()

    // 遷移元ページ情報がない場合
    if (!prevPage) {
      this.$router.push('/academy/notice')
      return
    }

    this.$router.push({
      path: prevPage.path,
      query: prevPage.query,
    })
  }

  /**
   * 編集ボタン押下時の処理
   */
  private eventClickEditButton(): void {
    this.$router.push({
      path: `/academy/notice/${this.messageId}/edit`,
      query: this.$prevPage.generateQuery(),
    })
  }

  /**
   * 削除ボタン押下時の処理
   */
  private async eventClickDeleteButton(): Promise<void> {
    if (!confirm('削除してよろしいですか？')) {
      return
    }

    this.$loading.start()

    // 削除処理の実行
    await ManageNotificationsApi.deleteNotification(this.messageId)

    this.$loading.complete()

    // 一覧へ遷移
    await this.$router.push('/academy/notice')
  }

  /**
   * お知らせをapiから取得
   *
   * @returns お知らせ情報
   */
  private async getMessage(): Promise<NoticeMessageData> {
    const noticeDetail = await NotificationsApi.notification(this.messageId)
    return {
      id: noticeDetail.id,
      type: noticeDetail.type,
      title: noticeDetail.title,
      startedDate: new Date(noticeDetail.startedAt * 1000),
      endedDate: new Date(noticeDetail.endedAt * 1000),
      description: noticeDetail.message,
      updatedUser: noticeDetail.updatedBy,
      updatedAt: new Date(noticeDetail.updatedAt * 1000),
    }
  }
}
